import { useCreatePurchaseMapping } from 'api/MappingsAPI';
import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { usePurchaseMappingsContext } from 'modules/dataDictionary/contexts';
import { useCreateFieldModal } from 'modules/dataDictionary/hooks';
import { MappingFieldValues } from 'modules/dataDictionary/types';
import { createFieldPayload } from 'modules/dataDictionary/utils';
import { useFormContext } from 'react-hook-form';
import { CreateFieldModal } from './CreateFieldModal';

export const CreatePurchaseFieldModal = ({ parentName }: { parentName: string }) => {
  const { setError } = useFormContext();
  const { refetchPurchaseMappings: refetch, purchaseMappings } = usePurchaseMappingsContext();
  const { project } = useCustomEventsQueryContext();
  const { handleSubmit, hasError, isDisabled, isSubmitting, onClose, onError, onSuccess } =
    useCreateFieldModal({ refetch });

  const { mutate } = useCreatePurchaseMapping({ onSuccess, onError });

  const onSubmit = (data: MappingFieldValues) => {
    const payload = createFieldPayload(data, project?.id, parentName);
    const existingField = purchaseMappings.find((field) => field.fieldName === payload?.fieldName);

    if (existingField) {
      setError('fieldName', { message: 'Duplicate name' });
      return null;
    }

    if (payload && !existingField) {
      mutate(payload);
    }
  };

  return (
    <CreateFieldModal
      handleSubmit={handleSubmit(onSubmit)}
      hasError={hasError}
      isDisabled={isDisabled}
      isSubmitting={isSubmitting}
      onClose={onClose}
      parentName={parentName}
    />
  );
};
